import React, { useState, useEffect } from "react";
import axios from "axios";

const SeminarImages = () => {
  const [images, setImages] = useState([]);

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await axios.get(
          "https://skpbackend.quindl.com/gallery/seminar"
        );
        const data = response.data;
        const formattedData = data.map((item, index) => {
            const imagePath = item.images || item.location;
            return {
                id: index + 1,
                src: imagePath ? `https://skpbackend.quindl.com${imagePath}` : "",
                alt: `Seminar Image ${index + 1}`,
                text: item.title,
                content: item.content,
            };
        });
        setImages(formattedData);
      } catch (error) {
        console.error("Error fetching seminar images:", error);
      }
    };
    fetchImages();
  }, []);

  return (
    <div className="image-container">
      {images.map((img) => (
        <div key={img.id} className="image-wrapper">
          <img
            src={img.src}
            alt={img.alt}
            className="carousel-image"
            onError={(e) => {
              e.target.src = "https://via.placeholder.com/300x300?text=Seminar+Image";
            }}
          />
          <div className="image-text">
            <h4>{img.text}</h4>
            <p style={{fontSize: '14px', fontWeight: '400', marginTop: '5px'}}>{img.content}</p>
          </div>
        </div>
      ))}
      {images.length === 0 && <p>No seminar images found.</p>}
    </div>
  );
};

export default SeminarImages;
